<template>
  <t-form label-width="90px">
    <!-- v-if="cptDataForm.dataSource == '4'" -->
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="字体">
      <t-select v-model="attribute.fontFamily" size="small">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
      </t-select>
    </t-form-item>
    <t-form-item label="文字大小">
      <t-input-number :min="13" :max="200" v-model="attribute.fontSize" size="small"/>
    </t-form-item>
    <t-form-item label="文字颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.color" size="small"/>
    </t-form-item>
    <t-form-item label="边距">
      <t-input-number :min="1" :max="200" v-model="attribute.padding" size="small"/>
    </t-form-item>
    <t-form-item label="圆角">
      <t-input-number :min="0" :max="100" v-model="attribute.borderRadius" size="small"/>
    </t-form-item>
    <t-form-item label="背景颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.bgColor" size="small" enableAlpha/>
    </t-form-item>
    <t-form-item label="千分位隔符" help="刷新数据生效">
      <t-switch v-model="attribute.showSeparator" :label="['显示', '不显示']" size="small"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-rect-num-option",
  props: {
    attribute: Object,cptDataForm:Object,currentCpt:Object
  },
  components: {CptData},
  computed:{
    textFamilyList(){
      return require('@/assets/font/font-list')
    }
  }
}
</script>

<style scoped>

</style>
